import { PublicClientApplication } from "@azure/msal-browser";

const tenant = import.meta.env.VITE_AZURE_TENANT_ID || "common";
const MICROSOFT_REDIRECT_PENDING_KEY = "betonijerry.microsoft.redirect.pending";
const MICROSOFT_LOGIN_REQUEST = {
    scopes: ["openid", "profile", "email"],
    prompt: "select_account",
};

export const msalInstance = new PublicClientApplication({
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${tenant}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
});

let initPromise = null;
export function ensureMsalReady() {
    // handleRedirectPromise() must run after initialize() to flush any
    // msal.interaction.status left behind by an interrupted flow (closed
    // popup, mid-flow reload, two concurrent login starts). Without it,
    // the next loginPopup throws BrowserAuthError: interaction_in_progress
    // and the user can't sign in until they manually clear sessionStorage.
    if (!initPromise) {
        initPromise = msalInstance.initialize()
            .then(() => msalInstance.handleRedirectPromise());
    }
    return initPromise;
}

export async function loginWithMicrosoftRedirect() {
    localStorage.setItem(MICROSOFT_REDIRECT_PENDING_KEY, "true");
    try {
        // loginRedirect throws uninitialized_public_client_application unless
        // initialize() ran first. On a fresh page (no pending redirect)
        // ensureMsalReady() was never reached, so init here — it's cached/idempotent.
        await ensureMsalReady();
        await msalInstance.loginRedirect({
            ...MICROSOFT_LOGIN_REQUEST,
            redirectUri: window.location.origin,
        });
    } catch (error) {
        localStorage.removeItem(MICROSOFT_REDIRECT_PENDING_KEY);
        throw error;
    }
}

export async function completeMicrosoftRedirectLogin({ loginWithMicrosoft, reaffirmAcceptances = async () => {} }) {
    if (localStorage.getItem(MICROSOFT_REDIRECT_PENDING_KEY) !== "true") return false;

    const result = await ensureMsalReady();
    if (!result?.idToken) return false;

    localStorage.removeItem(MICROSOFT_REDIRECT_PENDING_KEY);
    const authData = await loginWithMicrosoft(result.idToken);
    await reaffirmAcceptances(authData);
    return true;
}
